import { Icon } from "../../../../components";
import BusinessCard from "../business-card";
import BCCreate from "../business-card/pages/BC-create";
import BCDetail from "../business-card/pages/BC-detail";
import BCEdit from "../business-card/pages/BC-edit";

export const businessCardRoutes = {
  businessCard: {
    isAdmin: false,
    parentId: "procedure",
    title: "8. Đề nghị in danh thiếp",
    icon: <Icon.Collection />,
    path: "/procedure/business-card",
    component: BusinessCard,
  },
  createBusinessCard: {
    isAdmin: false,
    parentId: "procedure",
    path: "/procedure/business-card/create",
    component: BCCreate,
  },
  editBusinessCard: {
    isAdmin: false,
    parentId: "procedure",
    path: "/procedure/business-card/:id/edit",
    component: BCEdit,
  },
  businessCardDetail: {
    isAdmin: false,
    parentId: "procedure",
    path: "/procedure/business-card/:id",
    component: BCDetail,
  },
};
